(function AmexBenefitsModal($, Adzuki)
{
	'use strict';

	$(document).ready(function onDocumentReady()
	{
		// Open AMEX Credit Card benefits modal
		if ($('.view-amex-benefits').length > 0) {
			$('.view-amex-benefits').click(function onAmexBenefitsModalClick(event)
			{
				var modal_container = $('.amex-benefits-modal');
				var modal_title     = modal_container.find('.amex-benefits-modal-title').html();
				var modal_html      = modal_container.find('.amex-benefits-modal-body').html();

				event.preventDefault();

				$('.modal-title').text(modal_title);
				$('.modal-body').html(modal_html);
				$('.modal').modal('show');
			});
		}
	});

}(jQuery, window.Adzuki || {}));
